import { DatePipe } from '@angular/common';
import { Component, effect, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { BytesConverterPipe, SiaColorContrastAutoDirective } from '@sia/shared';
import { FormatExtractedValuePipe } from '../../pipes/format-extracted-value.pipe';
import { HasExtractedValuePipe } from '../../pipes/has-extracted-value.pipe';
import { AiGridFileComponent } from '../ai-grid-file/ai-grid-file.component';

@Component({
  selector: 'sia-ai-grid-file-information-view',
  imports: [
    BytesConverterPipe,
    DatePipe,
    MatIcon,
    SiaColorContrastAutoDirective,
    FormatExtractedValuePipe,
    HasExtractedValuePipe,
  ],
  templateUrl: './ai-grid-file-information-view.component.html',
  styleUrl: './ai-grid-file-information-view.component.scss',
})
export class AiGridFileInformationViewComponent extends AiGridFileComponent {
  showFileName = input<boolean>(true);

  retriveInformationEffect = effect(async () => {
    let file = this.file();
    await this.retriveAdditionalInformations();
  });
}
